import { URLType } from './url.config';

export function reporting(prefix: string): URLType {
  return {
    /** Gestion transactions : Etats*/
    TRANSACTIONS: `${prefix}/transactions`,
    /** Gestion porteur : Etats*/
    CARDHOLDERS: `${prefix}/cardholders`,
    /** Gestion prépayé : Etats*/
    PREPAID: `${prefix}/prepaid`,
    /** Gestion commercant : Etats*/
    MERCHANT: `${prefix}/merchant`,
    /** VISA BASE 2 : Rapports*/
    VISA_BASE_2: `${prefix}/visa-base-2`,

    /** Gestion débit : Etats*/
    DEBIT: `${prefix}/debit`,
    /** Gestion Fraude : Etats*/
    FRAUD: `${prefix}/fraud`,
    /** GIMAC : Etats*/
    GIMAC: `${prefix}/gimac`,
  };
}
